import RestError from '../../modules/app/errors';

export const REASON_PIN_INVALID = 'PIN_INVALID';
export const REASON_PIN_BLOCKED = 'PIN_BLOCKED';
export const REASON_TOO_MANY_METHODS = 'TOO_MANY_PAYMENT_METHODS';
export const REASON_DEPOSIT_LIMITS_EXCEED = 'DEPOSIT_LIMITS_EXCEED';
export const REASON_SELF_EXCLUDED = 'SELF_EXCLUDED';
export const REASON_ONLINE_ABOVE_MAXIMUM = 'ONLINE_ABOVE_MAXIMUM';
export const REASON_WITHDRAWAL_DECLINED = 'WITHDRAWAL_DECLINED';

export const OPEN_BET_REASON_INSUFFICIENT_BALANCE = 'PMT_ERROR_INSUFFICIENT_BALANCE';
export const OPEN_BET_REASON_WINNINGS_LOCKED = 'PMT_ERROR_WINNINGS_LOCKED';
export const OPEN_BET_REASON_PMB_LOCKED = 'PMT_ERROR_PMB_LOCKED';

export class WithdrawBadRequestError extends RestError {
}

export class WithdrawForbiddenError extends RestError {
}

export class WithdrawPendingError extends RestError {
}
